<template>
    <div>
        <section class="sell_your_device_dashboard_default text-center" style="min-height:80vh">
            <div class="container-fluid">
                <div class="service_top_section__img_section text-center" :style="{'width':'100%'}">
                    <div class="row">
                        <Sidebar></Sidebar>
                        <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8 mb-4 cat-block-device">
                            <div class="container-fluid">
                                <div class="container">   
                                    <div class="page">
                                        <h1 class="order-table-header-h">Your Purchase - In-Progress Item</h1>
                                        <table class="layout display invoice_table responsive-table">
                                            <thead>
                                                <tr class="text-white">
                                                    <th>SL</th>
                                                    <th>Invoice ID</th>
                                                    <th>Quantity</th>
                                                    <th>Price</th>
                                                    <th>Invoice Status</th>
                                                    <th>Purchase Time</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <template v-if="this.inProgressOrderData.length">
                                                    <tr v-for="(row, index) in this.inProgressOrderData" :key="index">
                                                        <td class="organisationnumber">{{ index+1 }}</td>
                                                        <td class="organisationnumber">{{ row.invoice_id }}</td>
                                                        <td class="organisationnumber">{{ row.quantity }}</td>
                                                        <td class="organisationnumber">${{ row.price }}</td>
                                                        <td class="organisationnumber">{{ row.invoice_status }}</td>
                                                        <td class="organisationname">{{ row.created_at }}</td>
                                                        <td class="actions">
                                                            <a href="javascript:void(0);" @click="viewPurchaseInvoice(row.invoice_id)" class="btnorder orange"><i class="fa fa-eye" aria-hidden="true"></i> View Order </a>
                                                        </td>
                                                    </tr>                                            
                                                </template>
                                                <template v-else>
                                                    <tr>
                                                        <td class="organisationnumber" colspan="7">{{ statusMessage }}</td>
                                                    </tr>
                                                </template>
                                            </tbody>
                                        </table>
                                    </div>                                                                  
                                </div>
                            </div>                              
                        </div>
                    </div>                   
                </div>
            </div>
        </section>  
    </div>
</template>
<style src="./css/common.css"></style>
<script>
    import Sidebar from "../layout/Sidebar.vue";
    import {authHeader} from "../../auth";

    export default {
        components: {
            Sidebar
        },
        data() {
            return {
                inProgressOrderData: [],
                message: "",
                statusMessage: "No Record Found",   
            }
        },
        created() {
            document.title = 'Geek Buy Back - All In Progress Order';
            this.getPurchaseOrderInProgressData();
        },
        methods:{
            getPurchaseOrderInProgressData: function() {
                var config = {
                    method: "GET",
                    url: this.$api + this.$config.dashboard.purchaseOrderInProgressURL,
                    headers: authHeader()
                };
                this.$axios(config).then(response => {
                    if(response.data.status == "success") {
                        this.inProgressOrderData = response.data.data;
                        if(this.inProgressOrderData.length == 0)
                        {
                            this.message = this.statusMessage;
                        }
                    }
                }).catch(error => {
                    console.log(error);
                });  
            },
            viewPurchaseInvoice: function(invoiceID) {
                this.$router.push({
                    name: 'user-purchase-order-detail', 
                    params: { 
                        invoiceID: invoiceID 
                    }
                });
            },       
        }
    }
</script>
